import { useEffect, useState } from 'react'
import { Button, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ProgressBar } from '~/@ui/progress-bar/ProgressBar'
import { SimplePageWrapper } from '~/@ui/simple-page-wrapper/SimplePageWrapper'
import CApartmentSvg from '~/@ui/_sharedSvgs/properties/c_Apartment.svg?react'
import CHouseSvg from '~/@ui/_sharedSvgs/properties/c_House.svg?react'
import { useAlert } from '~/@ui/alert/useAlert'
import { useAdress } from './useAdress'
import { CustomAddressAutocomplete } from './CustomAddressAutocomplete'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'
import { getApi } from '~/@utils/api/getApi'
import { useCurrentUserData } from '~/@biz_account/useCurrentUserData/useCurrentUserData'
import { Header } from '~/@ui/header/Header'

export const PropertyAdressPage = () => {
  const navigate = useNavigate()
  const { showAlert } = useAlert()
  const { user } = useCurrentUserData()

  const [buildingType, setBuildingType] = useState<'flat' | 'house'>('flat')
  const [selectedAddress, setSelectedAddress] = useState('')
  const [isValidAddress, setIsValidAddress] = useState(false)
  const [error, setError] = useState(false)

  const {
    handleAddressChange,
    handleAddressSelect: hookHandleAddressSelect,
    predictions,
    coordinates,
  } = useAdress()

  const isApartment = buildingType === 'flat'
  const isHouse = buildingType === 'house'

  const checkIfOrderExist = async () => {
    if (user?._ownerPensionOrder?.id) {
      navigate('/vlastnik/portfolio/overview')
    }
  }

  const handleAddressSelect = (prediction: any) => {
    setSelectedAddress(prediction.description)
    hookHandleAddressSelect(prediction)
  }

  const createOrder = async () => {
    try {
      const { data: response } =
        await getApi().ownerEstateAppApiControllerCreateOwnerEstate({
          type: buildingType,
          address: selectedAddress,
          x: coordinates?.latitude ?? 0,
          y: coordinates?.longitude ?? 0,
        })

      if ('success' in response) {
        navigate(
          `/vlastnik/dotaznik/informacie-o-nehnutelnosti/${response.ownerEstate.id}`
        )
        return
      }

      throw new Error(
        'Nasatala neznáma chyba pri odosielaní kontaktného formulára.'
      )
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    }
  }

  const handleSubmit = async () => {
    if (!isValidAddress) {
      setError(true)
      showAlert('error', 'Prosím vyberte adresu')
      return
    }

    createOrder()
  }

  useEffect(() => {
    checkIfOrderExist()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  return (
    <SimplePageWrapper
      onClickBack={() =>
        navigate('/vlastnik/dotaznik/informacie-o-ziadatelovi')
      }>
      <Stack className="px-5 pb-28">
        <ProgressBar
          className="mt-[26px]"
          manualPercentage={[100, 100, 0, 0]}
        />
        <Header
          title="Údaje o nehnuteľnosti"
          text="Vlastníte byt alebo dom? Na akej adrese?"
          className="mt-3"
        />

        <Stack className="gap-3 mt-8">
          <Stack className="flex-row gap-3">
            <Stack
              className={`w-full h-[120px] justify-center items-center gap-2 ${isApartment ? 'bg-zBlack200' : 'bg-zGrey200'} rounded-4d cursor-pointer transition-colors duration-200`}
              onClick={() => setBuildingType('flat')}>
              <CApartmentSvg
                className={
                  isApartment ? 'stroke-zWhite200' : 'stroke-zBlack200'
                }
              />
              <Typography
                className={`text-3d font-medium ${isApartment ? 'text-zWhite200' : 'text-zBlack200'}`}>
                Byt
              </Typography>
            </Stack>

            <Stack
              className={`w-full h-[120px] justify-center items-center gap-2 ${isHouse ? 'bg-zBlack200' : 'bg-zGrey200'} rounded-4d cursor-pointer transition-colors duration-200`}
              onClick={() => setBuildingType('house')}>
              <CHouseSvg
                className={isHouse ? 'stroke-zWhite200' : 'stroke-zBlack200'}
              />
              <Typography
                className={`text-3d font-medium ${isHouse ? 'text-zWhite200' : 'text-zBlack200'}`}>
                Dom
              </Typography>
            </Stack>
          </Stack>

          <CustomAddressAutocomplete
            placeholder="Zadajte adresu nehnuteľnosti"
            value={selectedAddress}
            onChange={setSelectedAddress}
            onAddressSelect={handleAddressSelect}
            predictions={predictions}
            onInputChange={handleAddressChange}
            className="w-full"
            isValidAddress={isValidAddress}
            setIsValidAddress={setIsValidAddress}
            error={error}
            setError={setError}
          />
        </Stack>

        <Button
          variant="contained"
          className="w-fit h-14 self-center px-10 mt-[72px]"
          onClick={handleSubmit}>
          Pokračovať
        </Button>
      </Stack>
    </SimplePageWrapper>
  )
}
